module.exports = __webpack_public_path__ + "img/Microsoft_Office_Excel.d910cedd.svg";